import { CUSTOM_ELEMENTS_SCHEMA, Component, computed, input } from '@angular/core';
import { getRequerimentoStatusCor } from '../../../core/constants/requerimento-online-opcoes';

/**
 * Tag de status do requerimento online: o `vivest-tag` do design system com as cores de
 * `getRequerimentoStatusCor`, que não cabem nas variantes da tag (amarelo, laranja, azul...).
 */
@Component({
  selector: 'app-requerimento-status-tag',
  standalone: true,
  // Web component do design system Vivest (`vivest-tag`).
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './requerimento-status-tag.component.html',
  styleUrl: './requerimento-status-tag.component.scss',
})
export class RequerimentoStatusTagComponent {
  readonly status = input<string | null | undefined>(null);

  readonly cor = computed(() => getRequerimentoStatusCor(this.status()));
}
